module.exports = __webpack_public_path__ + "img/test-exam-icon.ba4d6a48.png";